import React, { useState } from 'react';
import { Routes, Route, Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import CombatDetail from './pages/CombatDetail';
import Profile from './pages/Profile';
import MyBets from './pages/MyBets';
import Payments from './pages/Payments';
import HelpCenter from './pages/HelpCenter';
import Contact from './pages/Contact';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import ConditionsUtilisation from './pages/ConditionsUtilisation';
import Game from './pages/Game';
import AdminDashboard from './pages/admin/Dashboard';
import AdminCombats from './pages/admin/Combats';
import AdminUsers from './pages/admin/Users';
import AdminReports from './pages/admin/Reports';
import CreateCombat from './pages/admin/CreateCombat';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Preloader from './components/Preloader';

function App() {
  const { user } = useAuthStore();
  const [loading, setLoading] = useState(true);

  if (loading) {
    return <Preloader onComplete={() => setLoading(false)} />;
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Redirection personnalisée pour la racine */}
          <Route
            index
            element={
              user
                ? user.role === 'admin'
                  ? <Home />
                  : <Navigate to="/game" replace />
                : <Navigate to="/login" replace />
            }
          />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="help" element={<HelpCenter />} />
          <Route path="contact" element={<Contact />} />
          <Route path="politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="conditions-utilisation" element={<ConditionsUtilisation />} />
          <Route path="combats/:id" element={<CombatDetail />} />

          {/* Routes protégées */}
          <Route element={<ProtectedRoute />}>
            <Route path="profile" element={<Profile />} />
            <Route path="my-bets" element={<MyBets />} />
            <Route path="payments" element={<Payments />} />
            <Route path="game" element={<Game />} />
          </Route>

          {/* Routes admin */}
          <Route element={<AdminRoute />}>
            <Route path="admin" element={<Outlet />}>
              <Route index element={<AdminDashboard />} />
              <Route path="combats" element={<AdminCombats />} />
              <Route path="combats/new" element={<CreateCombat />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="reports" element={<AdminReports />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;